var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDotss({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 24,
    viewBox: "0 0 8 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.57063 10.96C2.98663 10.576 3.51463 10.368 4.18663 10.368C4.84263 10.368 5.38663 10.576 5.80263 10.96C6.21863 11.344 6.44263 11.872 6.44263 12.512C6.44263 13.168 6.21863 13.696 5.80263 14.08C5.38663 14.464 4.84263 14.656 4.18663 14.656C3.51463 14.656 2.98663 14.464 2.57063 14.08C2.15463 13.696 1.94662 13.168 1.94662 12.512C1.94662 11.872 2.15463 11.344 2.57063 10.96Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotss);
export default __webpack_public_path__ + "static/media/dotss.0f8bb602fff0d65d01e2f21be4e01427.svg";
export { ForwardRef as ReactComponent };